"use client";

import { type ReactNode, useEffect } from "react";
import { startSyncService } from "@/features/forms/offline/sync";

export function OfflineSyncProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Audio chunks/sessions strand in IndexedDB exactly like form submissions
    // do if the tech navigates away mid-recording-sync — and the audio engine
    // is otherwise only kicked from the recorder UI. Kick it here so pending
    // audio drains from ANY page. Dynamic import keeps the audio engine out of
    // pages that never record; kickSync self-initialises its own poll loop and
    // is a fast no-op when the queue is empty. Never disposed: the engine is a
    // page-lifetime singleton and this provider mounts at the app root.
    void import("@/features/audio-assistant/offline/sync").then(({ kickSync }) =>
      kickSync(),
    );
    return startSyncService();
  }, []);

  return <>{children}</>;
}
